<template>
  <div class="pay-tool">
    <div class="pay-tool__icon" v-if="payToolIcon" v-html="payToolIcon"></div>
    <div class="pay-tool__text">
      {{ payTool }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    payTool: {
      type: String,
      default: null,
    },
  },
  name: 'TransactionPayTool',
  PAY_TOOL_ICONS: {
    card: `<svg width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.56196 0.458252H0.695245C0.311231 0.458252 0 0.750133 0 1.11004V1.43594H6.25721V1.11004C6.25721 0.750133 5.94543 0.458252 5.56196 0.458252ZM0 4.369C0 4.72892 0.311231 5.0208 0.695245 5.0208H5.56196C5.94597 5.0208 6.25721 4.72892 6.25721 4.369V2.41363H0V4.369ZM2.07596 3.79869C2.07596 3.75365 2.11487 3.71721 2.16286 3.71721H3.71739C3.76538 3.71721 3.80429 3.75365 3.80429 3.79869L3.82385 3.96163C3.82385 4.00663 3.78494 4.04311 3.73694 4.04311H2.17264C2.12484 4.04311 2.08574 4.00645 2.08574 3.96163L2.07596 3.79869ZM0.685468 3.79869C0.685468 3.75365 0.72438 3.71721 0.772374 3.71721H1.64143C1.68942 3.71721 1.72834 3.75365 1.72834 3.79869L1.73811 3.96163C1.73811 4.00645 1.69901 4.04311 1.65121 4.04311H0.782151C0.734135 4.04311 0.695245 4.00645 0.695245 3.96163L0.685468 3.79869Z" fill="#465A8B"/></svg>`,
    cardpay: `<svg width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.56196 0.458252H0.695245C0.311231 0.458252 0 0.750133 0 1.11004V1.43594H6.25721V1.11004C6.25721 0.750133 5.94543 0.458252 5.56196 0.458252ZM0 4.369C0 4.72892 0.311231 5.0208 0.695245 5.0208H5.56196C5.94597 5.0208 6.25721 4.72892 6.25721 4.369V2.41363H0V4.369ZM2.07596 3.79869C2.07596 3.75365 2.11487 3.71721 2.16286 3.71721H3.71739C3.76538 3.71721 3.80429 3.75365 3.80429 3.79869L3.82385 3.96163C3.82385 4.00663 3.78494 4.04311 3.73694 4.04311H2.17264C2.12484 4.04311 2.08574 4.00645 2.08574 3.96163L2.07596 3.79869ZM0.685468 3.79869C0.685468 3.75365 0.72438 3.71721 0.772374 3.71721H1.64143C1.68942 3.71721 1.72834 3.75365 1.72834 3.79869L1.73811 3.96163C1.73811 4.00645 1.69901 4.04311 1.65121 4.04311H0.782151C0.734135 4.04311 0.695245 4.00645 0.695245 3.96163L0.685468 3.79869Z" fill="#465A8B"/></svg>`,
    applepay: `<svg width="6" height="7" viewBox="0 0 6 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.08058 1.12175C3.81884 1.41564 3.40005 1.64745 2.98127 1.61433C2.92892 1.21696 3.13395 0.794748 3.37388 0.533971C3.63562 0.231801 4.09366 0.0165572 4.46446 0C4.50809 0.413931 4.33795 0.819584 4.08058 1.12175ZM4.4601 1.69298C3.85374 1.65986 3.33462 2.01998 3.04671 2.01998C2.75443 2.01998 2.31384 1.70954 1.83398 1.71781C1.21017 1.72609 0.629978 2.06138 0.311529 2.59535C-0.34282 3.66329 0.141398 5.24451 0.773935 6.11376C1.08366 6.54425 1.45446 7.01613 1.94304 6.99958C2.40544 6.98302 2.58866 6.71396 3.14704 6.71396C3.70978 6.71396 3.87119 6.99958 4.35977 6.9913C4.8658 6.98302 5.18425 6.56081 5.49397 6.13032C5.84732 5.64188 5.99128 5.16586 6 5.14102C5.99128 5.13275 5.02284 4.78091 5.01411 3.72124C5.00539 2.83543 5.77752 2.41322 5.81242 2.38838C5.37619 1.77576 4.69566 1.70954 4.4601 1.69298Z" fill="#465A8B"/></svg>`,
    googlepay: `<svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.05448 3.15374C6.05448 2.92838 6.03426 2.71273 5.99673 2.50537H3.0918V3.69339L4.7648 3.69375C4.69694 4.08904 4.47857 4.426 4.14397 4.65065V5.42142H5.13983C5.72132 4.88465 6.05448 4.0912 6.05448 3.15374Z" fill="#4285F4"/><path d="M4.1441 4.65051C3.86689 4.837 3.50991 4.94608 3.09229 4.94608C2.28557 4.94608 1.60121 4.40391 1.35612 3.6731H0.328857V4.46799C0.837798 5.47529 1.88383 6.1665 3.09229 6.1665C3.92753 6.1665 4.62922 5.89253 5.13997 5.42093L4.1441 4.65051Z" fill="#34A853"/><path d="M1.25936 3.08343C1.25936 2.87823 1.29365 2.67986 1.35609 2.49338V1.69849H0.328825C0.118391 2.11501 0 2.58518 0 3.08343C0 3.58168 0.118752 4.05185 0.328825 4.46837L1.35609 3.67348C1.29365 3.487 1.25936 3.28863 1.25936 3.08343Z" fill="#FABB05"/><path d="M3.09229 1.22042C3.54818 1.22042 3.95641 1.37702 4.27874 1.68303L5.16126 0.803534C4.62525 0.305646 3.92645 0 3.09229 0C1.88419 0 0.837798 0.691212 0.328857 1.69851L1.35612 2.4934C1.60121 1.76259 2.28557 1.22042 3.09229 1.22042Z" fill="#E94235"/></svg>`,
  },
  computed: {
    payToolIcon() {
      return (
        this.$options.PAY_TOOL_ICONS[
          this.payTool.replaceAll(' ', '').toLowerCase()
        ] || null
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.pay-tool {
  display: flex;
  align-items: center;
  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(97, 128, 199, 0.2);
    border-radius: 4px;
    margin-right: 7px;

    svg {
      max-width: 100%;
      max-height: 100%;
    }
  }

  &__text {
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    color: #1a1f29;
    opacity: 0.7;
  }
}
</style>
